// @flow
import decode from 'jwt-decode'

export const getTokenExpirationDate = (token: string): any => {
  try {
    const decoded: { exp: number } = decode(token)
    if (!decoded.exp) {
      return null
    }

    const date = new Date(0) // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp)
    return date
  } catch (e) {}

  return null
}

export const isTokenExpired = (token: string): boolean => {
  const date: Date | null = getTokenExpirationDate(token)
  const offsetSeconds = 0
  if (date === null) {
    return false
  }
  return !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)))
}
